import React, {useEffect, useState} from "react";
import axios from "../common/axios";
import PagedList from "../common/PagedList";

const SchoolAdmins = props => {
    const {callback} = props;
    const [listLoading, setListLoading] = useState(true);
    const columns = [
        {title: 'Name', dataIndex: 'name', key: 'name'},
        {title: 'Username', dataIndex: 'username', key: 'username'},
        {title: 'Email', dataIndex: 'email', key: 'email'}
    ]
    const [dataSource, setDataSource] = useState([]);

    useEffect(() => {
        setListLoading(true);
        axios.get('/web/ui/myClasses/viewSchoolAdmins')
            .then(response => {
                setDataSource(response.data.map(user => {
                    return {
                        key: user.userId,
                        name: user.fullName,
                        username: user.username,
                        email: <a href={`mailto:${user.email}`}>{user.email}</a>
                    }
                }));
                setListLoading(false);
            });
        if (callback && typeof callback === 'function') callback();
    }, []);

    return (
        <>
            <p className="padding--rm">If your class lists are incorrect, contact one of your administrators, listed below. Or click on an administrator's name to email them.</p>
            <PagedList className="margin-t--l" columns={columns} dataSource={dataSource} loading={listLoading} size={"small"} pagination={false} />
        </>
    )
}

export default SchoolAdmins;